export default "__VITE_ASSET__DYk4OeLQ__"